/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('UtpSysMessagesServiceApi', ($http, ApiErrorService) => {
    return {
        userMessagesCount: userMessagesCount,
        userMessages: userMessages,
        createMessage: createMessage,
        markAsRead: markAsRead
    };
    function userMessagesCount() {
        return $http.get(`api/UtpSysMessages/UserMessagesCount`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function userMessages() {
        return $http.get(`api/UtpSysMessages/UserMessages`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function createMessage(req) {
        return $http.post(`api/UtpSysMessages/CreateMessage`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function markAsRead(messageId) {
        return $http.post(`api/UtpSysMessages/MarkAsRead?messageId=${messageId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
